import InitFormSubmit from "./formSubmit";

export default function initAjaxFormsScripts() {
    InitFormSubmit();
}


// WEBPACK FOOTER //
// ./uPortal/Content/js/AjaxForms/index.js